import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {property} from 'lit/decorators/property.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import seluxLogo from '../../../../icons/selux-logo';
import {baseProfileOptions, luminaryOptions} from '../../lightProfileSectionConfig';



@customElement('page-header')
export class PageHeader extends connect(store)(LitElement) {

	static styles = css`

		:host {
			color: #000;
		}
		.title {
			margin-top: 2cqw;
			font: var(--font-specsheet-print-bold);
			font-size: 2.5cqw;

		}
		.intro {
			font: var(--font-specsheet-print-light);
			font-size: 2cqw;
		}
		.label {
			margin-top: 2cqw;
			font: var(--font-specsheet-print-light);
			font-size: 1cqw;
		}

	`;


	@property({type: String})
	title = '';

	@property({type: String})
	intro = '';

	@property({type: String})
	labelChoice = '';

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
		this.translations = state.productData.translations;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.productData = state.productData.productData;
		this.lang = state.status.lang;
		this.projectName = this.lightProfile.project.projectName ?? '';
	}

	connectedCallback() {
		super.connectedCallback();
	}

	render() {
		const lmo = luminaryOptions.find(luminaryOption => luminaryOption.id === this.lightProfile.project.luminary);
		const bpo = baseProfileOptions.find(baseProfileOption => baseProfileOption.id === this.lightProfile.project.base);
		const profileLabel = bpo ? bpo.label[this.lang] : '';
		const prefixedLabel = html`<br>${msg('Circular light profile')}: ${profileLabel}`;
		const summary = html`${msg('Circular light profile')}: ${profileLabel}`;
		const summaryLabel = html`${summary} ${when(this.projectName !== '', () => html` ${msg('for')} ${this.projectName}`)}`;
		const lightLabel = lmo ? html`<br>${lmo.label[this.lang]}` : '';


		let chosenLabel = '';
		if (this.labelChoice === 'light') {
			chosenLabel = lightLabel;
		} else if (this.labelChoice === 'profile') {
			chosenLabel = prefixedLabel;
		} else if (this.labelChoice === 'summary') {
			chosenLabel = summaryLabel;
		}

		return html`
			<div class="header">
				<div class="title">${this.title}</div>
				${this.intro ? html`<div class="intro">${this.intro}</div>` : ''}
				<div class="label">${chosenLabel}</div>
			</div>
		`;
	}
}
